function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M36,3.474C36,1.427,34.149,0,31.5,0S27,1.427,27,3.474V5.21H24V18.525H39V5.21H36Zm-7.5,0c0-1.4,1.177-2.316,3-2.316s3,.907,3,2.316V5.21h-6Zm5.173,11.6a3.872,3.872,0,0,1-1.423.454V16.5h-1.5v-1c-1.3-.217-2.462-.948-2.462-2.13h1.5c0,.825,1.168,1.042,1.787,1.042a2.461,2.461,0,0,0,1.193-.271.789.789,0,0,0,.442-.724c0-.482-.7-.724-1.851-1.074-1.228-.369-2.756-.829-2.756-2.1a1.839,1.839,0,0,1,1.009-1.592,3.605,3.605,0,0,1,1.138-.4V7.236h1.5v.973c1.234.168,2.325.837,2.325,1.971h-1.5c0-.676-.909-.857-1.447-.857s-1.522.2-1.522.926c0,.446.681.683,1.8,1.013,1.251.376,2.813.844,2.813,2.152a1.892,1.892,0,0,1-1.044,1.65Z",
  transform: "translate(-24)"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 15,
    height: 18.525,
    viewBox: "0 0 15 18.525"
  }, props), _ref);
};

export default __webpack_public_path__ + "storage/static/media/sales-order.92e8a75a.svg";
export { SvgComponent as ReactComponent };